import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    breadcrumb:[],
    user:{
        id:'',
        js:'',
        jsmc:'',
        yhm:'',
        zsxm:"",
        jgId:''
    },
	message:{
		type:'',
		content:'',
		okCallBack:()=>{},
		cancelCallBack:()=>{}
	},
    privileges:[],
	privilegeCodes:[],
    currentMenus:[],
	activeModule:'',
    activeMenu:{},
	showLoading:false,
	showReturnBackBtn:false
  },
  mutations: {
	initStore(state){
		state.breadcrumb = [];
		state.user = {
				id:'',
				js:'',
				jsmc:'',
				yhm:'',
				zsxm:"",
				jgId:'',
		};
		state.privileges = [];
		state.privilegeCodes = [];
		state.currentMenus = [];
		state.activeModule = '';
		state.activeMenu = {};
		state.message = {
			type:'',
			content:'',
			okCallBack:()=>{},
			cancelCallBack:()=>{}
		};
	},
    setUser(state, user) {
        state.user = user;
		setTimeout(function(){//更新缓存
			localStorage.setItem("jxjy_store_user",JSON.stringify(user));
		},1000);
    },
    setPrivileges(state, privileges) {
        state.privileges = privileges;
		setTimeout(function(){//更新缓存
			localStorage.setItem("jxjy_store_privileges",JSON.stringify(privileges));
		},1000);
    },
	setPrivilegeCodes(state, privilegeCodes) {
	    state.privilegeCodes = privilegeCodes;
		setTimeout(function(){//更新缓存
			localStorage.setItem("jxjy_store_privilege_codes",JSON.stringify(privilegeCodes));
		},1000);
	},
    setBreadcrumb(state, breadcrumb){
        state.breadcrumb = breadcrumb;
		setTimeout(function(){//更新缓存
			sessionStorage.setItem("jxjy_store_breadcrumbs",JSON.stringify(breadcrumb));
		},1000);
    },
    setCurrentMenus(state, currentMenus){
        state.currentMenus = currentMenus;
		setTimeout(function(){//更新缓存
			sessionStorage.setItem("jxjy_store_currentMenus",JSON.stringify(currentMenus));
		},1000);
    },
    setActiveMenu(state,activeMenu){
        state.activeMenu = activeMenu;
		setTimeout(function(){//更新缓存
			sessionStorage.setItem("jxjy_store_activeMenu",JSON.stringify(activeMenu));
			console.log('kkkk:'+JSON.stringify(activeMenu));
		},1000);
    },
	setActiveModule(state,activeModule){
        state.activeModule = activeModule;
		setTimeout(function(){//更新缓存
			sessionStorage.setItem("jxjy_store_activeModule",activeModule);
		},1000);
    },
	setShowLoading(state,showLoading){
		state.showLoading = showLoading;
	},
	setMessage(state,message){
		state.message = message;
	},
	setShowReturnBackBtn(state,showReturnBackBtn){
		state.showReturnBackBtn = showReturnBackBtn;
	}
  },
  actions: {},
  modules: {}
});
